module.exports = __webpack_public_path__ + "img/column_yingbi.a1fabfad.png";